// Import libraries
import { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-scroll";

// Import components
import Header from "../components/Header";
import JoinForm from "../components/JoinForm";

// Import assets
import BigBot from "../assets/img/AdaBot/ada-home-bot.png";
import { IoIosArrowDown } from "react-icons/io";

// Import static files
import sponsors from "../static/sponsors.json";

/**
 * Welcome page
 * @returns
 */
const Home = () => {
	// Initialize animations
	useEffect(() => {
		AOS.init({
			easing: "ease", // default easing for AOS animations
			once: true, // whether animation should happen only once - while scrolling down
			mirror: false, // whether elements should animate out while scrolling past them
			anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
		});
	}, []);

	return (
		<main id="main-content">
			<div id="home-image" className="mx-auto static p-5 md:p-5 relative animate-fade-in-down">
				{/* Welcome title */}
				<title
					id="home-title"
					className="flex flex-col place-items-center mx-auto inline-block w-11/12 pt-2 z-30 mt-32"
				>
					<Header
						title="ADA'S TEAM"
						subtitle="Promoting diversity and inclusivity in technology."
						homepage
					/>
					{/* Arrow */}
					<div id="jump-arrow" className="text-5xl py-20 animate-pulse">
						<Link to="home-information" smooth={true}>
							<IoIosArrowDown size="2em" />
						</Link>
					</div>
				</title>

				{/* Bot image */}
				<img
					id="home-bot"
					src={BigBot}
					alt="Ada's Home Bot waving"
					className="absolute inset-y-0 right-0 hidden w-1/4 sm:block"
				/>
			</div>

			<section id="home-information" className="bg-black w-full py-20">
				<div className="max-w-4xl mx-8 md:mx-24 lg:mx-64 xl:mx-auto">
					<div className="divider-thick my-6" aria-hidden />
					<div data-aos="fade-left" data-aos-duration="500" data-aos-easing="ease-in-sine">
						<h2 className="text-2xl font-title mb-4">TREATY 6 ACKNOWLEDGEMENT</h2>
						<p className="font-body font-light text-white">
							We respectfully acknowledge that Ada's Team is located on Treaty 6 territory, a
							traditional gathering place for diverse Indigenous peoples including the Cree,
							Blackfoot, Metis, Nakota Sioux, Iroquois, Dene, Ojibway/Saulteaux/Anishinaabe, Inuit,
							and many others whose histories, languages, and cultures continue to influence our
							vibrant community.
						</p>
					</div>
				</div>
			</section>

			<section
				data-aos="fade-in"
				data-aos-duration="500"
				data-aos-easing="ease-in-sine"
				id="join-us-form"
				className="max-w-6xl mx-8 my-8 md:my-24 animate-fade-in-down md:mx-16 xl:mx-auto"
			>
				<h2 className="title">JOIN OUR MAILING LIST</h2>
				<p className="my-5 font-body">
					Subscribe to our mailing list to receive updates on events, opportunities, scholarships,
					and more!
				</p>
				<JoinForm />
			</section>

			{/*
			<section
				id="tutoring"
				data-aos="fade-in"
				data-aos-duration="500"
				data-aos-easing="ease-in-sine"
				className="max-w-6xl mx-8 my-8 md:my-24 animate-fade-in-down md:mx-16 xl:mx-auto"
			>
				<div className="divider-thick mt-16 mb-8" aria-hidden />

				<h2>TUTORING</h2>

				<p className="py-3 font-body font-light">
					Thanks to the time and effort of our wonderful volunteers, we are able to provide FREE
					drop-in tutoring for our members. The tutors offer help with various CMPUT, MATH and STAT
					courses.
				</p>

				<p className="py-3 font-body font-light">
					To take advantage of our services, you can join the Slack channel below. There, you can
					post in different channels and ask for help. You can also book online sessions, or drop in
					when a tutor has office hours.
				</p>

				<div id="tutoring-links" className="flex flex-col gap-4 md:flex-row my-4">
					<a
						className="w-full md:w-max flex justify-center items-center self-center py-3 px-5
								bg-blue text-white font-semibold rounded-lg hover:text-white hover:bg-pink"
						href="https://join.slack.com/t/adastutoring/shared_invite/zt-rxka4nnk-Ox~fBNx2XgXkU4gk9TLQfw"
						alt="Ada's Team Tutoring Slack Invite Link"
						target="_blank"
						rel="noreferrer"
					>
						<span className="pr-2 text-lg">
							<FaSlack />
						</span>
						Join Ada's Students Slack
					</a>

					<a
						className="w-full md:w-max flex justify-center items-center self-center py-3 px-5
								bg-blue text-white font-semibold rounded-lg hover:text-white hover:bg-pink"
						href="https://calendar.google.com/calendar/embed?src=v9j8ohim8qc5g8af4bfm5409ac%40group.calendar.google.com&ctz=America%2FEdmonton"
						alt="Ada's Team Tutoring Hours Calendar"
						target="_blank"
						rel="noreferrer"
					>
						<span className="pr-2 text-lg">
							<FaCalendarWeek />
						</span>
						View In-person Office Hours
					</a>

					<a
						className="w-full md:w-max flex justify-center items-center self-center py-3 px-5
								bg-blue text-white font-semibold rounded-lg hover:text-white hover:bg-pink"
						href="https://calendar.google.com/calendar/u/0/selfsched?sstoken=UUljZjZTQVBhYkdBfGRlZmF1bHR8NGFkMDk2YmNhNzI1OWQxNDhjYWRlZmVkNWEyMzlmYjU"
						alt="Ada's Team Appointment Booking Center"
						target="_blank"
						rel="noreferrer"
					>
						<span className="pr-2 text-lg">
							<FaCalendarPlus />
						</span>
						Book Online Appointments
					</a>
				</div>
			</section>
			*/}
			
			{sponsors[0] && (
				<section
					id="sponsors-list"
					data-aos="fade-in"
					data-aos-duration="500"
					data-aos-easing="ease-in-sine"
					className="max-w-6xl mx-8 my-8 md:my-24 animate-fade-in-down md:mx-16 xl:mx-auto"
				>
					<div className="divider-thick mt-16 mb-8" aria-hidden />

					<h2>SPONSORS</h2>

					<div className="mb-8 grid grid-cols-2 grid-rows-3 md:grid-cols-3  md:grid-rows-2 lg:my-10">
						{sponsors &&
							sponsors.map(({ company_name, image }) => (
								<Sponsor company={company_name} image={image} key={company_name} />
							))}
					</div>
				</section>
			)}
		</main>
	);
};

// Sponsor subcomponent
const Sponsor = ({ company, image }) => (
	<div className="flex self-center justify-self-center flex-col items-center justify-between mt-8">
		<img src={image} className="w-32 h-auto md:w-40 md:h-auto" alt={company + " logo"} />
		<h4 className="text-base uppercase text-center mt-2">{company}</h4>
	</div>
);

export default Home;
